import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";
import TopLabelCustomSelectBox from "../TopLabelReactSelect/TopLabelReactSelect";
import { StatusOptions } from "../../utils/constants";

import styles from "./AcademicActivites.module.css";

const FundedResearchProjects = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "fundedResearchProjects",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        projectTitle: "",
        fundingAgency: "",
        role: "",
        duration: "",
        status: "",
        grantAmount: "",
      });
    }
  }, [fields, append]);

  return (
    <div className={styles.borderBox}>
      <div className={styles.heading}>
        <h2>C. Funded Research Projects</h2>

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid3} key={item.id}>
          <Input
            label="Project Title"
            name={`fundedResearchProjects[${idx}].projectTitle`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Funding Agency"
            name={`fundedResearchProjects[${idx}].fundingAgency`}
            register={register}
            errors={errors}
            disabled={disabled}
          />

          <Input
            label="Role"
            name={`fundedResearchProjects[${idx}].role`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Duration"
            name={`fundedResearchProjects[${idx}].duration`}
            register={register}
            errors={errors}
            duration
            disabled={disabled}
          />

          <TopLabelCustomSelectBox
            label="Status"
            name={`fundedResearchProjects[${idx}].status`}
            register={register}
            errors={errors}
            placeholder="Select"
            options={StatusOptions}
            control={control}
            disabled={disabled}
          />
          <Input
            label="Grant Amount (Optional)"
            name={`fundedResearchProjects[${idx}].grantAmount`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}

      <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                projectTitle: "",
                fundingAgency: "",
                role: "",
                duration: "",
                status: "",
                grantAmount: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default FundedResearchProjects;
